import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../Api.jsx";
import { UserContext } from "../../context/UserContext";

// Funzione per decodificare il token JWT
const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1];
    const decoded = atob(payload);
    const parsed = JSON.parse(decoded);
    return parsed;
  } catch (error) {
    console.error("❌ Error decoding token:", error);
    return null;
  }
};

const Login = () => {
  const { setUser } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/user/login", { email, password });
      const data = response.data;
      localStorage.setItem("token", data.token);

      // Forza il recupero dei dati utente completi decodificando il token
      const decodedUser = decodeToken(data.token);
      const userId = decodedUser?.id;
      if (userId) {
        const userResponse = await api.get(`/user/${userId}`);
        setUser(userResponse.data);
      }

      toast.success("Login effettuato con successo!");
      navigate("/");
    } catch (err) {
      if (err.response) {
        const msg = err.response.data.error || "Credenziali non valide";
        setError(msg);
        toast.error(msg);
      } else {
        setError("Errore di connessione al server");
        toast.error("Errore di connessione al server");
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-global px-4">
      <div className="w-full max-w-md  p-8 rounded-2xl">
       <img
      src={`${process.env.PUBLIC_URL}${process.env.REACT_APP_LOGO_PATH}`}
      className="w-32 mx-auto py-6"
      alt="Logo"
    />
        <h2 className="text-2xl font-semibold text-center mb-6 text-white">
          Accedi al tuo account
        </h2>

        {error && (
          <div className="mb-4 p-3 text-sm text-red-700 bg-red-100 border border-red-300 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-white mb-1">
              Email
            </label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-xl bg-secondary text-white mb-6"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-primary border-2 border-green-500 rounded-full mt-6 text-white"
          >
            Accedi
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
